import React from "react";
import "./style.css";
import {formatCheeseName} from "../../../../../utils/common";

import { Image } from "../../../../../components/Image";
export const PcProfileSummary = ({ bmi, left, data }) => {
  return (
    <div className="profile-summary-pc" data-model-id="16867:7030">


      <div className="contents">
        <h1 className="text-center text-[24px] leading-[32px] font-[600] tracking-[0px] text-[#151E13]">
          Summary of Your Personal Profile
        </h1>

        <div className="container">
          <div className="div">
            <div className="BMI-label-wrapper">
              <p className="BMI-label">Your Body Mass Index (BMI)</p>
            </div>

            <div className="frame-2">
              <div className="frame-3">
                <div className="frame-4" />

                <div className="frame-5">
                  <div className="text-wrapper">Normal</div>

                  <div className="text-wrapper-2">Overweight</div>

                  <div className="text-wrapper-2">Obese</div>
                </div>
              </div>

              <div className="frame-6" style={{left}}>
                <div className="BMI-value-wrapper">
                  <div className="BMI-value">You - {bmi}</div>
                </div>

                <div className="BMI-indicator">
                  <Image src="/static/image/questionnaire/weight-loss/profile-summary/pc/vector-2936.svg" alt="Vector" className="vector" />

                  <div className="ellipse" />
                </div>
              </div>
            </div>

            {bmi > 24 &&<div className="risk-container">
              <div className="risk-info">
                <Image src="/static/image/questionnaire/weight-loss/profile-summary/pc/icon-alert.png" alt="Icon alert" className="icon-alert" />

                <div className="risk-title">Risk of unhealthy BMI</div>
              </div>

              <p className="risk-description">
                Higher risk of heart disease, stroke, diabetes, and chronic
                pain.
              </p>
            </div>}
          </div>

          <div className="frame-7">
            <div className="area">
              <div className="list">
                <div className="div-2">
                  <Image src="/static/image/questionnaire/weight-loss/profile-summary/pc/age-icon.png" alt="Age icon" className="age-icon" />
                </div>

                <div className="goal">
                  <div className="text-wrapper-3">Age</div>

                  <div className="fitness-level">{data.age}</div>
                </div>
              </div>

              <div className="list">
                <div className="div-2">
                  <div className="overlap-group">
                    <div className="ellipse-2" />

                    <div className="ellipse-3" />

                    <div className="ellipse-4" />

                    <div className="ellipse-5" />

                    <Image src="/static/image/questionnaire/weight-loss/profile-summary/pc/rectangle-112.svg" alt="Rectangle" className="rectangle" />

                    <Image src="/static/image/questionnaire/weight-loss/profile-summary/pc/vector-873.svg" alt="Vector" className="img" />

                    <Image src="/static/image/questionnaire/weight-loss/profile-summary/pc/vector-874.svg" alt="Vector" className="vector-2" />

                    <Image src="/static/image/questionnaire/weight-loss/profile-summary/pc/vector-872.svg" alt="Vector" className="vector-3" />

                    <div className="target-weight-icon" />
                  </div>
                </div>

                <div className="goal">
                  <div className="text-wrapper-3">Target Weight</div>

                  <div className="fitness-level">{data.targetWeight.weight} {data.targetWeight.unit}</div>
                </div>
              </div>

              <div className="list">
                <div className="div-2">
                  <div className="overlap-group-2">
                    <Image src="/static/image/questionnaire/weight-loss/profile-summary/pc/vector-51.svg" alt="Vector" className="vector-4" />

                    <Image src="/static/image/questionnaire/weight-loss/profile-summary/pc/vector-50.svg" alt="Vector" className="vector-5" />

                    <div className="active-level-icon" />

                    <div className="active-level-icon-2" />

                    <div className="active-level-icon-3" />

                    <Image src="/static/image/questionnaire/weight-loss/profile-summary/pc/intersect.svg" alt="Intersect" className="intersect" />

                    <Image src="/static/image/questionnaire/weight-loss/profile-summary/pc/subtract.svg" alt="Subtract" className="subtract" />
                  </div>
                </div>

                <div className="goal">
                  <div className="text-wrapper-3">Activity Level</div>

                  <div className="fitness-level">{data.activityLevel}</div>
                </div>
              </div>
            </div>

            <div className="f">
              <div className="overlap">
                <Image src={`/static/image/questionnaire/weight-loss/profileSummary/ProfileSummary${formatCheeseName(data.gender)}${formatCheeseName(data.targetBodyType, "")}.png`} alt="Beautiful shadows" className="beautiful-shadows" />
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};
